<script setup>
</script>

<template>
  <main class="container" aria-labelledby="titre-erreur">
    <h1 id="titre-erreur">Une erreur s'est produite</h1>
  </main>
</template>

<style scoped lang="scss">

</style>
